var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box-text"},[_c('van-cell',{attrs:{"center":"","title":_vm.item.title,"value":_vm.item.data}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }